import axios from "~/plugins/axios";

const baseUrl = "/web_api/v1/mortgage_part";

export default {
  getByMortgageId(mortgageId) {
    return axios.get(`${baseUrl}/by_mortgage/${mortgageId}`)
      .then((response) => response.data);
  },
  deleteMortgagePart(mortgagePartId) {
    return axios.delete(`${baseUrl}/${mortgagePartId}`)
      .then((response) => response.data);
  },
  updateMortgagePart(mortgagePartId, mortgagePart) {
    return axios.put(`${baseUrl}/${mortgagePartId}`, mortgagePart)
      .then((response) => response.data);
  },
  saveMortgagePart(mortgageId, mortgagePart) {
    const partObject = mortgagePart; // prevent ESLint error: no-param-reassign
    partObject.mortgage_id = mortgageId;

    return axios.post(baseUrl, partObject)
      .then((response) => response.data);
  },
};
